import { render, staticRenderFns } from "./FraisTransportTranche.vue?vue&type=template&id=c2d350ae&scoped=true&"
import script from "./FraisTransportTranche.vue?vue&type=script&lang=js&"
export * from "./FraisTransportTranche.vue?vue&type=script&lang=js&"
import style0 from "./FraisTransportTranche.vue?vue&type=style&index=0&id=c2d350ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d350ae",
  null
  
)

component.options.__file = "FraisTransportTranche.vue"
export default component.exports